exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout-tree--border[data-v-208d4b38] {\n  box-shadow: 0 0 0 1px #808080;\n}\n", ""]);

